import axios from 'axios'
import qs from 'qs'

const Func = {
  getInstance({ method, path, data }) {
    const token = localStorage.getItem('access_token')
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    if (token) headers.Authorization = 'Bearer ' + token

    let instance = {
      method: method,
      url: path,
      headers: headers
    }

    if (method.toUpperCase() === 'GET') {
      // for GET
      instance.params = data || null
    } else {
      // for POST PUT DELETE
      instance.data = data ? qs.stringify(data) : null
    }

    return instance
  },
  async setAuthenticationToken() {
    // const response = await Models.Call('POST', '/authen/token', {
    //   grant_type: 'password',
    //   username: 'admin',
    //   password: 'admin'
    // })
    // localStorage.setItem('access_token', response.access_token)
  }
}

const Models = {
  async Call({ method, path, data }) {
    try {
      const instance = Func.getInstance({ method, path, data })
      const response = await axios(instance)

      if (path.includes('/authen/token') || path.includes('/authen/social') || path.includes('/authen/getlineaccesstoken')) {
        // console.log(response)
        return response
      } else {
        // console.log(response.data)
        return response.data
      }
    } catch ({ response }) {
      console.warn(response)
      return response

      // if (response.status === 401) {
      //   return response
      // }
    }
  },
  Test() {
    Func.getAuthenticationToken()
  }
}

export default Models
